import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { loadOrderProductDetails, resetOrderDetails } from '@telstra-connect/order-tracker/methods/order-tracker-uplifted/order-summary';
import { ILoadOrderDetailsNewRequest } from '@telstra-connect/order-tracker/state/order-details';
import { IOrderTrackerAppState } from '@telstra-connect/order-tracker/state';
import { requestFailed, requestStarted, requestSucceeded } from '@telstra-connect/utils/data/request-helpers';
import { isStaffUser } from '@telstra-connect/login/methods/customer-type';
import { isSourceMpex } from '@telstra-connect/order-tracker/methods/order-tracker-uplifted';

/**
 * This custom hook fetches product order data based on the order number and cidn
 * provided in the URL parameters. It manages the state of the order details
 * and provides access to the API status and response data.
 */
const useProductOrderDataFetch = () => {
    const dispatch = useDispatch();
    const { orderNumber, cidn } = useParams();
    const state = useSelector((state: IOrderTrackerAppState) => state);
    const orderDetailsRequest: ILoadOrderDetailsNewRequest = state.orderTracker.orderDetailsNew;

    useEffect(() => {
        const fetchData = async () => {
          dispatch(loadOrderProductDetails(orderNumber, cidn));
        };
        if (!requestSucceeded(orderDetailsRequest) && !requestStarted(orderDetailsRequest)) {
          fetchData();
        }
        return () => {
          dispatch(resetOrderDetails())
        }
    }, [orderNumber]);

    return {
      isError: requestFailed(orderDetailsRequest) || !orderNumber || !cidn,
      isLoading: requestStarted(orderDetailsRequest),
      isSuccess: requestSucceeded(orderDetailsRequest),
      isMpexOrder: isSourceMpex(orderDetailsRequest?.data?.sourceSystem),
      isStaffUser: isStaffUser(state),
      orderNumber,
      cidn
    }
}

export default useProductOrderDataFetch;
